<template>
  <div class="owl-carousel testimonial-brand-slider owl-theme">
    <Carousel
        :breakpoints="breakpoints"
        :settings="settings"
        :autoplay="3000"
        :items-to-show="2"
        :wrap-around="true"
    >
      <Slide v-for="partner in partnerLogos" :key="partner.id">
        <div class="brand-logos" style="width: 75%">
          <img
              :alt="partner.name"
              :src="partner.imageUrl"
              style="width: 100%"
          />
        </div>
      </Slide>
      <template #addons></template>
    </Carousel>
  </div>
</template>

<script setup>
import {ref, onMounted} from "vue";
import {Carousel, Slide} from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import {getPartners} from "@/api/strapi/partner";
import {getImageUrl} from "@/api/strapi/image";

const partnerLogos = ref([]);

const settings = {
  snapAlign: "center",
  autoplayTimeout: 3000,
  pauseAutoplayOnHover: true,
};

const breakpoints = {
  375: {itemsToShow: 1, snapAlign: "center"},
  575: {itemsToShow: 2, snapAlign: "center"},
  767: {itemsToShow: 2, snapAlign: "center"},
  991: {itemsToShow: 3, snapAlign: "center"},
  1024: {itemsToShow: 6, snapAlign: "start"},
};

const fetchPartnerLogos = async () => {
  try {
    const response = await getPartners();
    const partners = response.data;

    if (partners?.length > 0) {
      partnerLogos.value = partners.map((partner) => {
        const logoData = partner.logo;
        return {
          id: partner.id,
          imageUrl: logoData ? getImageUrl(logoData.url) : "",
          name: partner.name || "Partner Logo",
        };
      });
    }
  } catch (error) {
    console.error("Lỗi lấy dữ liệu đối tác: ", error);
  }
};

onMounted(() => {
  fetchPartnerLogos();
});
</script>
